import { NotificationInstance } from 'antd/es/notification/interface';
import React, { useEffect } from 'react';
import { KEY_STORAGE, THEME_COLOR } from "../../util/varibles/constants";
import { IPropsChildren } from "../../util/varibles/interface";
import { ThemeProvider, useTheme } from "./ThemeContext";
import './theme.scss';

const ChangeTheme: React.FC<IPropsChildren> = ({ children }) => {
    const [theme] = useTheme(state => state.theme);

    useEffect(() => {
        const isSafari =
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
            document.documentElement.classList.add("is-safari");
        }
    }, []);

    useEffect(() => {
        document.body.className = `theme-${theme}`
    }, [theme]);
    return null
}

const Theme: React.FC<{ notify: NotificationInstance } & IPropsChildren> = ({ notify, children }) => {
    return <ThemeProvider notify={notify} theme={localStorage.getItem(KEY_STORAGE.THEME) as THEME_COLOR || THEME_COLOR.LIGHT}>
        <ChangeTheme />
        <div className='view'>{children}</div>
    </ThemeProvider>;
};

export default Theme;
